export const isInternalEmail = (email: string) => {
    return email.endsWith('@epohcj.com') || email.endsWith('@epoh.ng');
};
